import type { CSS } from '@components-shared/src/stitches';

export const activeStyles: CSS = {
  cursor: 'pointer',
  border: 'none',
  gap: 10,
  color: '$base800',
  '.active-indicator': {
    backgroundColor: '$base800',
  },
};
